import Vue from 'vue';

class FormErrors {
    constructor() {
        this.clear();
    }

    has(field) {
        return this.errors.hasOwnProperty(field);
    }

    any() {
        return Object.keys(this.errors).length > 0;
    }

    get(field) {
        if (this.errors[field])
            return this.errors[field][0];
    }

    apply(errors) {
        this.clear();
        Object.assign(this.errors, errors);
    }

    add(field, description) {
        if (!this.errors[field])
            Vue.set(this.errors, field, []);

        this.errors[field].push(description);
    }

    clear() {
        this.errors = {};
    }
};

export default FormErrors;
